import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { RequestTeacherPayoutBody } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const teacherRequestTeacherPayout = createAsyncThunk<void, RequestTeacherPayoutBody, { extra: Partial<Dependencies> }>(
  "payouts/teacherTriggerTeacherPayout",
  async (command: RequestTeacherPayoutBody, { extra: { teacherRepository } }) => {
    await teacherRepository!.requestTeacherPayout(command);
  },
);
